module.exports = "<div class=\"alert-message\">\n  {{ label }}\n</div>"